/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    SaveSurplusBulkUpload,
};

async function SaveSurplusBulkUpload(bulkModel) {
    const response = await CommonPost('/api/SurplusBulkUpload/SaveSurplusBulkUpload', null, bulkModel);
    return response;
}